var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadingIcon = function SvgLoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8BD4",
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m0 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.07 17.07c3.906-3.904 3.906-10.236 0-14.141-3.904-3.905-10.236-3.905-14.141 0a1.5 1.5 0 0 0 2.12 2.12 7 7 0 1 1 9.9 9.9 1.5 1.5 0 0 0 2.122 2.122"
  })));
};
export default SvgLoadingIcon;